"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.packageInfo = void 0;
// Copyright 2017-2023 @polkadot/util-crypto authors & contributors
// SPDX-License-Identifier: Apache-2.0

// Do not edit, auto-generated by @polkadot/dev

const packageInfo = {
  name: '@polkadot/util-crypto',
  path: typeof __dirname === 'string' ? __dirname : 'auto',
  type: 'cjs',
  version: '10.4.2'
};
exports.packageInfo = packageInfo;